export default __webpack_public_path__ + "static/4-730bf69ebc02cbf3688e59465715bce2.jpg";